import { call, CallEffect, put, PutEffect, SelectEffect, select } from "redux-saga/effects";
import { AxiosResponse } from "axios";
import { clearString } from "@/utils/functions";
import moment from "moment";
import { Action } from "redux-saga";
import { ReducersTypes } from "@/redux/reducers/Models";
import { automaticApi } from "@/settings/api";
import { getCustomerData } from "@/redux/ducks/customer";

export interface Fetch {
  email: string;
  birthdate: string;
  phone: string;
  homePhone: string;
  address: {
    type: string;
    zipcode: string;
    streetName: string;
    number: string;
    neighborhood: string;
    city: string;
    stateName: string;
    complement: string;
  };
  callback: (success: boolean, code?: string) => void;
}

export interface UpdateDataAction {
  type: string;
  payload: Fetch;
}

const uriUpdateCustomerData = "/customer/v1/account";
const uriUpdatePhones = "/customer/v1/phone";
const uriUpdateAdress = "/customer/v1/address";

const getCustomerReducer = (state: ReducersTypes) => state.customerReducer;

export default function* updateData({
  payload,
}: UpdateDataAction): Generator<
  CallEffect<unknown> | PutEffect<Action> | SelectEffect,
  void,
  AxiosResponse
> {
  try {
    // @ts-expect-error
    const customer: ReducersTypes["customerReducer"] =
      yield select(getCustomerReducer);

    const bodyPersonalData = {
      email: payload.email,
      dataNascimento: moment(payload.birthdate).format("YYYY-MM-DD"),
      idAccount: customer?.account?.id,
    };

    const bodyPhones = {
      cellPhone: {
        ddd: clearString(payload.phone).slice(0, 2),
        numberPhone: clearString(payload.phone).slice(2),
      },
      residential: {
        ddd: clearString(payload.homePhone).slice(0, 2),
        numberPhone: clearString(payload.homePhone).slice(2),
      },
    };

    const bodyAdress = {
      address: {
        typeAddress: payload.address.type.toUpperCase(),
        zipCode: clearString(payload.address.zipcode),
        street: payload.address.streetName,
        number: payload.address.number,
        neighborhood: payload.address.neighborhood,
        city: payload.address.city,
        state: payload.address.stateName,
        complement: payload.address.complement,
      },
    };

    const responseData = yield call(
      automaticApi.put,
      uriUpdateCustomerData,
      bodyPersonalData,
    );
    const customerDataSuccess: boolean = !!responseData.data?.flagAlteracao;

    const responsePhones = yield call(
      automaticApi.put,
      uriUpdatePhones,
      bodyPhones,
    );
    const customerPhonesSuccess: boolean =
      responsePhones?.data?.status?.codigoRetorno === 0;

    const responseAddress = yield call(
      automaticApi.put,
      uriUpdateAdress,
      bodyAdress,
    );
    const customerAddressSuccess: boolean =
      responseAddress.data?.status?.codigoRetorno === 0;

    if (
      customerDataSuccess &&
      customerPhonesSuccess &&
      customerAddressSuccess
    ) {
      yield put(getCustomerData());
      yield call(payload.callback, true);
    } else {
      yield call(payload.callback, false);
    }
  } catch (err) {
    yield call(payload.callback, false);
  }
}
